import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function OrderCancel() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6" data-testid="order-cancel-page">
      <div className="max-w-md w-full text-center">
        <XCircle className="w-12 h-12 text-black/30 mx-auto mb-6" />
        <h1 className="font-display text-3xl font-black tracking-tight text-ink">Payment canceled</h1>
        <p className="mt-3 text-black/55 text-sm">No charge was made. Your details are still in the checkout form if you'd like to try again.</p>
        <Link to="/#products" className="mt-6 inline-block bg-volt text-ink font-bold px-7 py-3.5 rounded-full hover:bg-voltdark hover:text-white transition-colors duration-300">
          Back to products
        </Link>
      </div>
    </div>
  );
}
